import { Controller } from '@hotwired/stimulus';

// Use a textarea input that can reset its height to the height of its content.
// Ex: resetting the height on input changes
//   <textarea
//     name="body"
//     placeholder="What are your thoughts?"
//     rows="1"
//     data-controller="auto-sized-textarea"
//     data-action="input->auto-sized-textarea#resetHeight"
//   ><%= view.body %></textarea>

class AutoSizedTextareaController extends Controller {
  static values = {
    maxRows: Number,
  };

  connect() {
    this._setOverflowStyles();
    this.resetHeight();
  }

  get rowHeightInPx() {
    const computedLineHeight = window.getComputedStyle(this.element).lineHeight;
    const lineHeightInPx = this._convertVerticalValueToPixels(computedLineHeight);

    return lineHeightInPx;
  }

  get verticalPaddingInPx() {
    const computedPaddingTop = window.getComputedStyle(this.element).paddingTop;
    const computedPaddingBottom = window.getComputedStyle(this.element).paddingBottom;
    const paddingTopInPx = this._convertVerticalValueToPixels(computedPaddingTop);
    const paddingBottomInPx = this._convertVerticalValueToPixels(computedPaddingBottom);

    return paddingTopInPx + paddingBottomInPx;
  }

  get maxHeightInPx() {
    if (this.maxRowsValue) {
      return this.verticalPaddingInPx + this.maxRowsValue * this.rowHeightInPx;
    }

    return null;
  }

  get heightInPx() {
    if (this.maxHeightInPx && this.element.scrollHeight > this.maxHeightInPx) {
      return this.maxHeightInPx;
    }

    return this.element.scrollHeight;
  }

  resetHeight() {
    this.element.style.height = 'auto';
    this.element.style.height = `${this.heightInPx}px`;
    this.element.scrollTo(0, this.element.scrollHeight);
  }

  // private

  _setOverflowStyles() {
    this.element.style.resize = 'none';
    this.element.style.overflow = 'hidden';

    if (this.maxRowsValue) {
      this.element.style.overflowY = 'auto';
    }
  }

  _convertVerticalValueToPixels(computedStyleValue) {
    if (computedStyleValue.includes('rem')) {
      const remValue = parseFloat(computedStyleValue);
      return this._convertRemToPixels(remValue);
    }

    if (computedStyleValue.includes('%')) {
      const percentageValue = parseFloat(computedStyleValue) / 100;
      return this._convertVerticalPercentageToPixels(percentageValue);
    }

    const computedStyleValueInPx = parseFloat(computedStyleValue);

    return computedStyleValueInPx;
  }

  _convertRemToPixels(remValue) {
    const rootElement = document.documentElement;
    const rootFontSizeinPx = parseFloat(window.getComputedStyle(rootElement).fontSize);
    const pixelValue = remValue * rootFontSizeinPx;

    return pixelValue;
  }

  _convertVerticalPercentageToPixels(percentageValue) {
    const containerWidthInPx = this.element.offsetWidth;
    const percentageValueInPx = percentageValue * containerWidthInPx;

    return percentageValueInPx;
  }
}

export default AutoSizedTextareaController;
